import { Box } from "@mui/material";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import { FilterOption } from "../Configs/ConfigsFilterItems";

const SELECTED_COLOR = "#9C27B0";
const UNSELECTED_COLOR = "#000000DE";

interface Props {
  objectTypeOptions: FilterOption[];
  selectedObjectTypes: string[];
  onSelectedObjectTypesChange: (value: string[]) => void;
  onClearFilters: () => void;
}

/**
 * The Dev Objects filter set. The options carry a row count in their label, so
 * they are passed explicitly rather than derived from the rows.
 *
 * FilterComponent owns the `devObjectFilters` query param and resets `page`
 * when a selection changes; it also renders the Clear Filter button.
 */
const DevObjectsFilterItems = ({
  objectTypeOptions,
  selectedObjectTypes,
  onSelectedObjectTypesChange,
  onClearFilters,
}: Props) => {
  const filterConfig = [
    {
      key: "object_type",
      name: "object_type",
      label: "Select an object_type",
      selectedOption: selectedObjectTypes,
      filterName: "object_type",
      options: objectTypeOptions,
      onSelectionChange: onSelectedObjectTypesChange,
      count: selectedObjectTypes.length,
      colorSelected:
        selectedObjectTypes.length > 0 ? SELECTED_COLOR : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: true,
    },
  ];

  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={onClearFilters}
        filterNameURL="devObjectFilters"
      />
    </Box>
  );
};

export default DevObjectsFilterItems;
